import {WorkDayModel} from './work-day.model';

export class WorkMonthModel {
  id: number;
  expertConfirmed: boolean = true;
  expensesClaim: number;
  workDays: WorkDayModel[] = [];
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/time-tracker/time-tracker-model/work-month.model.ts